import { useFormik } from "formik";
import React from "react";
import { Container, Form, FormGroup, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import * as Yup from "yup";
import SpinnerButton from "../../components/Button";
import { StyledSelect } from "../../components/StyledSelect";

/* eslint-disable */
const ContactoModal = ({ toggle, ticket, isSavingContactoCanal, ticketingCategories, handleContactoCanalSave }) => {
  const contact = ticket.CreadoPara;
  const CATEGORIES = ticketingCategories.categoria.reduce((acc, el) => {
    if (["Candidato", "Cliente", "Asociado"].includes(el.text)) {
      (el.label = el.text), (el.value = el.text);
      acc.push(el);
    }
    return acc;
  }, []);
  const categoria = CATEGORIES.find((cat) => cat.value == ticket.CreadoPara.categoriaCat.text) || CATEGORIES[0];

  const formik = useFormik({
    initialValues: {
      nombre: contact.nombre,
      apellido: contact.apellido,
      telefono: contact.telefono,
      dni: contact.dni,
      cuit: contact.cuit,
      titulo: contact.titulo,
      categoria: categoria,
    },
    onSubmit: async (data) => {
      formik.setSubmitting(true);
      if (data.categoria.value === "Candidato" || data.categoria === "Candidato") {
        data.categoria = 3;
      } else if (data.categoria.value === "Asociado" || data.categoria === "Asociado") {
        data.categoria = 5;
      } else {
        data.categoria = 1;
      }
      // ELIMINA LOS CAMPOS VACIOS DE LA DATA
      const cleanData = Object.entries(data).reduce((acc, el) => {
        if (el[1] !== "") {
          acc[el[0]] = el[1];
        } else {
          acc[el[0]] = null;
        }
        return acc;
      }, {});

      try {
        await handleContactoCanalSave(contact.itemId, cleanData, { formik });
        // eslint-disable-next-line no-empty
      } catch (err) {}
      formik.setSubmitting(false);
    },
    validationSchema: Yup.object().shape({
      nombre: Yup.string().required("Este campo es requerido."),
      apellido: Yup.string().required("Este campo es requerido."),
      telefono: Yup.string(),
      dni: Yup.string().nullable(),
      cuit: Yup.string().nullable(),
      titulo: Yup.string().required("Este campo es requerido."),
      categoria: Yup.object().nullable(),
    }),
  });

  return (
    <Modal centered backdrop="static" isOpen toggle={toggle}>
      <Form onSubmit={formik.handleSubmit}>
        <ModalHeader toggle={toggle}> Contacto </ModalHeader>
        <ModalBody>
          <Container fluid>
            <Row className="form-group">
              <label>Nombre</label>
              <input
                className={formik.errors.nombre && formik.touched.nombre ? "form-control error-field" : "form-control"}
                type="text"
                name="nombre"
                disabled={formik.isSubmitting}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.nombre}
              />
              {formik.errors.nombre && formik.touched.nombre && <div className="input-feedback">{formik.errors.nombre}</div>}
            </Row>
            <Row className="form-group">
              <label>Apellido</label>
              <input
                className={formik.errors.apellido && formik.touched.apellido ? "form-control error-field" : "form-control"}
                type="text"
                name="apellido"
                disabled={formik.isSubmitting}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.apellido === null ? undefined : formik.values.apellido}
              />
              {formik.errors.apellido && formik.touched.apellido && <div className="input-feedback">{formik.errors.apellido}</div>}
            </Row>
            <Row className="form-group">
              <label>DNI</label>
              <input
                className={formik.errors.dni && formik.touched.dni ? "form-control error-field" : "form-control"}
                type="text"
                name="dni"
                disabled={formik.isSubmitting}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.dni === null ? "" : formik.values.dni}
              />
              {formik.errors.dni && formik.touched.dni && <div className="input-feedback">{formik.errors.dni}</div>}
            </Row>
            <Row className="form-group">
              <label>CUIL</label>
              <input
                className={formik.errors.cuit && formik.touched.cuit ? "form-control error-field" : "form-control"}
                type="text"
                name="cuit"
                disabled={formik.isSubmitting}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.cuit === null ? "" : formik.values.cuit}
              />
              {formik.errors.cuit && formik.touched.cuit && <div className="input-feedback">{formik.errors.cuit}</div>}
            </Row>
            <Row className="form-group">
              <label>Email</label>
              <input
                className={formik.errors.titulo && formik.touched.titulo ? "form-control error-field" : "form-control"}
                type="text"
                name="titulo"
                disabled={formik.isSubmitting}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.titulo === null ? "" : formik.values.titulo}
              />
              {formik.errors.email && formik.touched.email && <div className="input-feedback">{formik.errors.email}</div>}
            </Row>
            <Row className="form-group">
              <label>Telefono</label>
              <input
                className={formik.errors.telefono && formik.touched.telefono ? "form-control error-field" : "form-control"}
                type="text"
                name="telefono"
                disabled={formik.isSubmitting}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.telefono === null ? "" : formik.values.telefono}
              />
              {formik.errors.telefono && formik.touched.telefono && <div className="input-feedback">{formik.errors.telefono}</div>}
            </Row>
            <Row className="form-group">
              <label>Público</label>
              <StyledSelect
                className={`w-100 ${formik.errors.categoria && formik.touched.categoria ? "error-field" : ""}`}
                id="categoria"
                name="categoria"
                formik={formik}
                defaultValue={categoria}
                isClearable
                isLoading={formik.isSubmitting}
                disabled={formik.isSubmitting}
                options={CATEGORIES}
              />
              {formik.errors.categoria && formik.touched.categoria && <div className="input-feedback">{formik.errors.categoria}</div>}
            </Row>
          </Container>
        </ModalBody>
        <ModalFooter>
          <FormGroup className="mb-0 px-3">
            <SpinnerButton className="btn btn-primary btn-block" isLoading={isSavingContactoCanal} disabled={isSavingContactoCanal} type="submit">
              Guardar
            </SpinnerButton>
          </FormGroup>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export { ContactoModal };
